import { setUser } from "./../store/actions/userActions";
import { baseUrl } from "./dataProvider";
const login = ({ email, password }) => {
  let fd = new FormData();
  fd.append("email", email);
  fd.append("password", password);
  return fetch(`${baseUrl}/auth/login`, {
    method: "post",
    body: fd,
    credentials: "include",
  });
};
function register(user = { name: "", email: "", password: "" }) {
  let fd = new FormData();
  fd.append("name", user.name);
  fd.append("email", user.email);
  fd.append("password", user.password);
  let xhr = new XMLHttpRequest();
  xhr.open("POST", `${baseUrl}/auth/register`);
  xhr.withCredentials = true;
  xhr.send(fd);
}

export { login, register };
